import AppLayoutV2 from "./AppLayoutV2";
export default AppLayoutV2;
